import CreneauHeureDebut from '@/generated/controls/creneau/CreneauHeureDebut.vue';
import { defineComponent } from "vue";

export default defineComponent({ components: {},
    extends: CreneauHeureDebut
})